import { InfiniteData, QueryClient, UseQueryResult } from '@tanstack/react-query';

import { GetRewardPoolsData } from '@shared/api/rewardPools';
import { RewardPool } from '@shared/api/types/rewardPools';
import {
  ALL_REWARD_POOLS_INFINITE_QUERIES_KEY,
  REWARD_POOL_QUERY_KEY,
} from '@shared/hooks/query/rewardPools';

export const setEntryInPools = ({
  poolId,
  entrieLeft,
  queryClient,
}: {
  poolId: number;
  entrieLeft: number;
  queryClient: QueryClient;
}) => {
  queryClient.setQueriesData(
    {
      queryKey: [ALL_REWARD_POOLS_INFINITE_QUERIES_KEY],
    },
    (data?: InfiniteData<GetRewardPoolsData>) => {
      if (!data) {
        return data;
      }

      return {
        ...data,
        pages: data.pages.map((page) => {
          return {
            ...page,
            pools: page.pools.map((pool) => {
              if (pool.id === poolId) {
                return {
                  ...pool,
                  entries_counter: (pool?.entries_max || 0) - entrieLeft,
                };
              }

              return pool;
            }),
          };
        }),
      };
    },
  );
};

export const setEntryInPool = ({
  poolId,
  entrieLeft,
  queryClient,
}: {
  poolId: number;
  entrieLeft: number;
  queryClient: QueryClient;
}) => {
  queryClient.setQueriesData(
    {
      queryKey: REWARD_POOL_QUERY_KEY(poolId),
    },
    (data?: UseQueryResult<RewardPool>['data']) => {
      if (!data) {
        return data;
      }

      return {
        ...data,
        entries_counter: (data?.entries_max || 0) - entrieLeft,
      };
    },
  );
};
